// Utility: strip empty-string values (and optionally null/undefined) from a shallow object.
// Useful when posting to backends that treat '' differently from undefined for optional fields.
export function stripEmpty(obj, { keepNulls = false, keepFalsy = true } = {}) {
  const out = {};
  for (const [k, v] of Object.entries(obj || {})) {
    if (v === '' || v === undefined) continue;
    if (v === null && !keepNulls) continue;
    if (!keepFalsy && !v) continue;
    out[k] = v;
  }
  return out;
}
